module.exports = __webpack_public_path__ + "static/media/Hotel-Hohenwart.cbca6d65.png";